import { Grid, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { useHistory } from 'react-router';
import i18n from 'i18n';
import styles from './styles';
import { TestConnectionResponse } from 'modules/clients/interfaces';

interface Props {
  testConnection: TestConnectionResponse | null;
}
const useStyles = makeStyles(styles);

const SimulateRemoteApp = ({ testConnection }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const [url, setUrl] = React.useState<string>();
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (testConnection?.url) {
      setUrl(testConnection.url);
    }
    setTimeout(() => {
      setLoading(false);
    }, 4500);
  }, [testConnection]);

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '90%' }}
    >
      {url && (
        <iframe
          src={url}
          style={{
            display: 'none',
          }}
          title="plugin autoSky"
          id="plugin_iframe"
        />
      )}
      <Grid className={classes.loadingContainer}>
        <img
          className={classes.loadingAppLogo}
          src="/images/AutoSkyLogoColorido.svg"
          alt="skyone logo"
        />
        {loading ? (
          <>
            <Typography className={classes.loadingAppText}>
              {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_LOADING_KEY')}
            </Typography>
            <CircularProgress className={classes.loadingAppIcon} />
          </>
        ) : (
          <>
            <CheckIcon className={classes.iconSuccess} fontSize="large" />
            <Typography className={classes.loadingAppText}>
              {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_FINISH_KEY')}
            </Typography>
            <Typography className={classes.loadingAppText}>
              {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_MSG_KEY')}{' '}
              <span
                className={classes.appNextStap}
                onClick={() =>
                  history.push(
                    '/clients/applications/simulate/remoteapp/install'
                  )
                }
              >
                {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_CLICK_HERE_KEY')}{' '}
              </span>
              {i18n.t('APPLICATIONS_PAGE.TEST_REMOTE_APP_CONFIRM_KEY')}
            </Typography>
          </>
        )}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  clients: { testConnection },
}: ApplicationState) => ({
  testConnection,
});

export default connect(mapStateToProps, {})(SimulateRemoteApp);
